import React from 'react';

const OnlineRequirements = () => {
  return (
  <div>
    <h4>Requisitos Técnicos</h4>
    <p style={{margin: '0px'}}>Para asegurar la correcta prestación del servicio será necesario que el equipo cumpla las siguientes especificaciones técnicas:</p>
    <ol>
      <li><strong>Conexión a internet mínima:</strong> 512 Kbps de subida/bajada.</li>
      <li><strong>Requisitos mínimos para PC y MAC:</strong> Microsoft Windows (versiones soportadas por el fabricante), Apple MAC OS (versiones soportadas por el fabricante, con procesador Intel).</li>
      <li><strong>Requisitos mínimos para Smartphones y Tablets:</strong> Android, iOS, Windows Phone.</li>
      <li><strong>Periféricos y dispositivos móviles:</strong> el usuario debe disponer del software de gestión y/o drivers del fabricante del dispositivo que sean compatibles con el sistema operativo instalado en el equipo del usuario.</li>
    </ol>

    <h4>Aplicaciones y dispositivos soportados</h4>
    <ol>
      <li>
        <strong>Aplicaciones soportadas:</strong>
        <ul>
          <li>Sistemas operativos: Mac OSX, Windows, iOS, Android (sistemas soportados por el fabricante).</li>
          <li>Programas de oficina: Microsoft Office, OpenOffice, NeoOffice, iWorks.</li>
          <li>Comunicación: Email, mensajería instantánea.</li>
          <li>Navegadores: IE, Firefox, Chrome, Safari, Opera.</li>
          <li>Seguridad: Antivirus y firewalls: Bitdefender, Microsoft Security Essentials, Panda, Symantec, McAfee, Kaspersky, Avg, Avast, etc.</li>
          <li>Utilidad: Grabación CD/DVD, compresión y ZIP.</li>
          <li>Multimedia: Adobe Acrobat, Windows Media Player, Real Player, iTunes, iLife, QuickTime, VLC, etc.</li>
          <li>Almacenamiento en la nube: SkyDrive, Google Drive, Dropbox, iCloud, Onedrive, etc.</li>
          <li>Software de gestión de dispositivos móviles: iTunes, Samsung Kies, Blackberry Desktop Software, Windows Phone for Desktop, etc.</li>
          <li>Herramientas del sistema y entornos de escritorio: Parallels, VMware Player, VirtualBox, etc.</li>
          <li>Almacenamiento en la nube: SkyDrive, Google Drive, Dropbox, iCloud, etc.</li>
          <li>Software de gestión de dispositivos móviles: iTunes, Samsung Kies, Blackberry Desktop Software, Nokia Suite, HTC Sync, Sony Ericcson PC Companion, Windows Phone for Desktop, etc.</li>
          <li>Gestión de drivers: exclusivamente para los sistemas operativos soportados.</li>
        </ul>
      </li>
      <li>
        <strong>Dispositivos soportados:</strong>
        <ul>
          <li>Ordenadores: sobremesa y portátiles.</li>
          <li>Periféricos de entrada: teclados, ratón, micrófono, escáner, cámara web, etc.</li>
          <li>Periféricos de salida: monitores, impresoras, altavoces, tarjetas de red, etc.</li>
          <li>Dispositivos móviles: smartphones y tablets.</li>
        </ul>
      </li>
    </ol>

    <p><strong>Notas:</strong></p>
    <ul>
      <li>(1) El pasado 8 de abril de 2014, Microsoft finalizó el soporte para Windows XP y Office 2003. Desde esta fecha, no habrá más actualizaciones de seguridad, parches para errores ni asistencia técnica, por lo tanto, no podremos asegurar que existan los medios necesarios para poder solventar las incidencias de los usuarios que utilicen este software.</li>
      <li>(2) No podremos asegurar la correcta prestación en el caso de que el idioma del sistema operativo y/o las aplicaciones soportadas sea diferente al idioma en el que se basa la prestación de este servicio.</li>
    </ul>
  </div>
  );
};

export default OnlineRequirements;
